import type { CSSProperties, FC } from 'react'
import type { VideoEmbedPropsApi } from '@/features/grid/videoEmbed/models'

const YoutubeEmbed: FC<VideoEmbedPropsApi> = props => {
    const { url, youtubeVideoHeight } = props
    const data = new URL(url)
    const v = data.searchParams.get('v')

    const style: CSSProperties = {
        width: '100%',
        aspectRatio: '16 / 9',
    }
    if (youtubeVideoHeight) {
        style.height = `${youtubeVideoHeight}px`
    }

    return (
        <iframe
            style={style}
            src={`https://www.youtube.com/embed/${v}`}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
        />
    )
}

export default YoutubeEmbed
